<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M21.6 5.99998V15.6c0 .6365-.2528 1.2469-.7029 1.697-.4501.4501-1.0606.703-1.6971.703h-6l-5.99998 4.8V18h-2.4c-.63652 0-1.24696-.2529-1.69705-.703-.45009-.4501-.70295-1.0605-.70295-1.697V5.99998c0-.63652.25286-1.24697.70295-1.69706.45009-.45009 1.06053-.70294 1.69705-.70294H19.2c.6365 0 1.247.25285 1.6971.70294.4501.45009.7029 1.06054.7029 1.69706Zm-13.19998 3.6h-2.4V12h2.4V9.59998Zm2.39998 0h2.4V12h-2.4V9.59998Zm7.2 0h-2.4V12H18V9.59998Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M5 5c-.26522 0-.51957.10536-.70711.29289C4.10536 5.48043 4 5.73478 4 6v8c0 .2652.10536.5196.29289.7071C4.48043 14.8946 4.73478 15 5 15h4c.55228 0 1 .4477 1 1v2.5858l3.2929-3.2929C13.4804 15.1054 13.7348 15 14 15h5c.2652 0 .5196-.1054.7071-.2929S20 14.2652 20 14V6c0-.26522-.1054-.51957-.2929-.70711C19.5196 5.10536 19.2652 5 19 5H5ZM2.87868 3.87868C3.44129 3.31607 4.20435 3 5 3h14c.7957 0 1.5587.31607 2.1213.87868C21.6839 4.44129 22 5.20435 22 6v8c0 .7957-.3161 1.5587-.8787 2.1213C20.5587 16.6839 19.7957 17 19 17h-4.5858l-4.70709 4.7071c-.286.286-.71612.3716-1.08979.2168C8.24364 21.7691 8 21.4045 8 21v-4H5c-.79565 0-1.55871-.3161-2.12132-.8787C2.31607 15.5587 2 14.7956 2 14V6c0-.79565.31607-1.55871.87868-2.12132ZM7 10c0-.55228.44772-1 1-1h.01c.55228 0 1 .44772 1 1 0 .5523-.44772 1-1 1H8c-.55228 0-1-.4477-1-1Zm4 0c0-.55228.4477-1 1-1h.01c.5523 0 1 .44772 1 1 0 .5523-.4477 1-1 1H12c-.5523 0-1-.4477-1-1Zm4 0c0-.55228.4477-1 1-1h.01c.5523 0 1 .44772 1 1 0 .5523-.4477 1-1 1H16c-.5523 0-1-.4477-1-1Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
